import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';
import { client } from './client';
import * as analytics from './endpoints/analytics';
import * as customerDownload from './endpoints/customer_download';
import * as gophoto from './endpoints/gophoto';
import * as payment from './endpoints/payment';
import * as photos from './endpoints/photos';
import * as portraits from './endpoints/portraits';
import * as printing from './endpoints/printing';
import * as session from './endpoints/session';

// Aggregate facade mapped onto the legacy RestApi method names. Existing
// call-sites use these. New code should import individual endpoint modules.
export const restApi = {
  // session
  createSession: session.create,
  getSessionById: session.getById,
  updateSessionById: session.updateById,
  recordPrivacyAcceptance: session.recordPrivacyAcceptance,

  // photos
  uploadPhotosWithFaceRecognition: photos.uploadPhotosWithFaceRecognition,
  getUploadedPhotosInSession: photos.getUploadedPhotosInSession,
  getUploadedPhotosInSessionSilent: photos.getUploadedPhotosInSessionSilent,

  // portraits
  submitGeneration: portraits.submitGeneration,
  getGenerationStatus: portraits.getGenerationStatus,
  submitGroupPortrait: portraits.submitGroupPortrait,
  reserveConfigs: portraits.reserveConfigs,
  sendGenerationCancel: portraits.sendGenerationCancel,
  upscaleB2CPortraits: portraits.upscaleB2CPortraits,

  // printing
  submitPrintJob: printing.submitPrintJob,
  getPrintJobStatus: printing.getPrintJobStatus,
  getPrintedPortraitsInSession: printing.getPrintedPortraitsInSession,

  // payment
  createPaymentIntent: payment.createPaymentIntent,
  sendPaymentIntentToReader: payment.sendPaymentIntentToReader,
  cancelPaymentOnReader: payment.cancelPaymentOnReader,
  checkPaymentIntentStatus: payment.checkPaymentIntentStatus,
  capturePaymentIntent: payment.capturePaymentIntent,
  holdPaymentIntent: payment.holdPaymentIntent,

  // gophoto
  setGophotoCode: gophoto.setGophotoCode,
  uploadToGophoto: gophoto.uploadToGophoto,

  // analytics / tracking
  trackSessionErrors: analytics.trackSessionErrors,
  trackPrintLock: analytics.trackPrintLock,
  trackPrintUnlock: analytics.trackPrintUnlock,

  // customer download portal (no kiosk api_key — auth via download_code in URL)
  postCustomerDownloadEngagement: customerDownload.postDownloadEngagement,
  postCustomerAnalyticsErrors: customerDownload.postAnalyticsErrors,

  // abort
  abortAllApiCalls: client.abortAll,
  abortGenerationRequests: client.abortGeneration,
  abortUploadRequests: client.abortUploads,
};

exposeToGlobalScope(restApi, 'RestApi');
